import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f7a6ffb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ss-div-pai"
}
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-div-imagem" }
const _hoisted_5 = { class: "ant-row ss-div-dados" }
const _hoisted_6 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo" }, "Esquecer a senha acontece, mais podemos resolver isso rapidamente.")
], -1))
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-24"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "ss-login-label" }, "Chave do Parceiro", -1))
const _hoisted_11 = { class: "ant-input-affix-wrapper ss-login-input" }
const _hoisted_12 = { class: "ant-input-prefix" }
const _hoisted_13 = {
  type: "user",
  role: "img",
  "aria-label": "user",
  class: "anticon anticon-user"
}
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "ss-login-label" }, "E-mail", -1))
const _hoisted_17 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_18 = { class: "ant-input-group-addon" }
const _hoisted_19 = { class: "ant-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_button = _resolveComponent("a-button")!

  return (!_ctx.storeSistema.state.carregando && !_ctx.telaBase.carregando)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_inline_svg, {
                style: {"width":"300px","height":"300px"},
                src: "/static/img/ilustracoes/esqueci-senha.svg"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_ctx.state.chaveParceiroAmbiente === undefined || _ctx.state.chaveParceiroAmbiente === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("span", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, [
                          _createVNode(_component_icone, { nome: "cadeado" })
                        ])
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.chaveParceiro) = $event)),
                        type: "text",
                        class: "ant-input hidden"
                      }, null, 512), [
                        [_vModelText, _ctx.state.chaveParceiro]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("span", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, [
                    _createVNode(_component_icone, {
                      class: "ss-icone",
                      nome: "email"
                    })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    style: {"text-align":"left"},
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.email) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.email]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_a_button, {
                type: "primary",
                class: "ss-login-btn",
                style: {"font-size":"12px","width":"100%","margin-top":"20px"},
                loading: _ctx.state.carregando,
                onClick: _ctx.enviarConfirmacaoEmail
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Enviar confirmação de e-mail ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}